var map = {
	"./background.jpg": 67,
	"./background@2x.jpg": 68
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 188;



//////////////////
// WEBPACK FOOTER
// ./themes/mf/img ^\.\/background.*\.jpg$
// module id = 188
// module chunks = 3